module.exports = __webpack_public_path__ + "img/See-a-DEMO-popup-en.922a052.png";